import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { PowerBIService } from '@max/shared/services/reports/power-bi.service';
import { map } from 'rxjs/operators';

@Injectable()
/**
 * Requires the currently logged in user & business unit to have access to the report they're trying to view.
 */
export class ReportsBusinessUnitNavGuard implements CanActivate {
    public routeReportName: string;

    constructor(
        private powerBIService: PowerBIService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        const reportName = route.paramMap.get('reportName');

        return this.powerBIService.getUserReportPermissions(reportName).pipe(
            map(permissions => {
                if (permissions) {
                    return true;
                }
            })
        );
    }
}
